module.exports = __webpack_public_path__ + "img/star-empty.09448f25.svg";